
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round"},style,staticStyle],
              attrs: Object.assign({"width":"40px","height":"40px","viewBox":"0 0 301 301","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/","style":"fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer-1","serif:id":"Layer 1","transform":"matrix(1,0,0,1,5.01562,-782.031)"}},[_c('g',{attrs:{"id":"g3837"}},[_c('path',{staticStyle:{"fill":"none","fill-rule":"nonzero","stroke":"white","stroke-width":"49.34px"},attrs:{"id":"path3785-0","d":"M19.668,1032.69L270.314,1032.69"}}),_c('path',{staticStyle:{"fill":"none","fill-rule":"nonzero","stroke":"white","stroke-width":"49.34px"},attrs:{"id":"path3785-0-9","d":"M19.668,932.694L270.314,932.694"}}),_c('path',{staticStyle:{"fill":"none","fill-rule":"nonzero","stroke":"white","stroke-width":"49.34px"},attrs:{"id":"path3785-0-4","d":"M19.668,832.694L270.314,832.694"}})])])])
          )
        }
      }
    